RegionObject.prototype.getAsciiChar = function (form) {
    var x = 0;
    var raw = form;
    var cooked = "";
    for (x = 0; x <= (raw.length - 1); x++) {
        var hex1 = raw.substring(x, x + 1);
        var hex2 = raw.substring(x + 1, x + 2);
        if ((hex1 >= 'a') && (hex1 <= 'f')) {
            hex1 = hex1.toUpperCase();
        }
        if ((hex2 >= 'a') && (hex2 <= 'f')) {
            hex2 = hex2.toUpperCase();
        }
        if (((hex1 >= 'A' && hex1 <= 'F') || (hex1 >= '0' && hex1 <= '9'))
            && ((hex2 >= 'A' && hex2 <= 'F') || (hex2 >= '0' && hex2 <= '9'))) {
            var hexbyte = hex1 + hex2;
            ascii = '.'; // Quite the brute force method here
            switch (hexbyte) {
                case '00':
                    ascii = '<NUL>';
                    break;
                case '01':
                    ascii = '<SOH>';
                    break;
                case '02':
                    ascii = '<STX>';
                    break;
                case '03':
                    ascii = '<ETX>';
                    break;
                case '04':
                    ascii = '<EOT>';
                    break;
                case '05':
                    ascii = '<ENQ>';
                    break;
                case '06':
                    ascii = '<ACK>';
                    break;
                case '07':
                    ascii = '<BEL>';
                    break;
                case '08':
                    ascii = '<BS>';
                    break;
                case '09':
                    ascii = '<HT>';
                    break;
                case '0A':
                    ascii = '<LF>';
                    break;
                case '0B':
                    ascii = '<VT>';
                    break;
                case '0C':
                    ascii = '<FF>';
                    break;
                case '0D':
                    ascii = chr(13);
                    break;
                case '0E':
                    ascii = '<SO>';
                    break;
                case '0F':
                    ascii = '<SI>';
                    break;
                case '10':
                    ascii = '<DLE>';
                    break;
                case '11':
                    ascii = '<DC1>';
                    break;
                case '12':
                    ascii = '<DC2>';
                    break;
                case '13':
                    ascii = '<DC3>';
                    break;
                case '14':
                    ascii = '<DC4>';
                    break;
                case '15':
                    ascii = '<NAK>';
                    break;
                case '16':
                    ascii = '<SYN>';
                    break;
                case '17':
                    ascii = '<ETB>';
                    break;
                case '18':
                    ascii = '<CAN>';
                    break;
                case '19':
                    ascii = '<EM>';
                    break;
                case '1A':
                    ascii = '<SUB>';
                    break;
                case '1B':
                    ascii = '<ESC>';
                    break;
                case '1C':
                    ascii = '<FS>';
                    break;
                case '1D':
                    ascii = '<GS>';
                    break;
                case '1E':
                    ascii = '<RS>';
                    break;
                case '1F':
                    ascii = '<US>';
                    break;
                case '20':
                    ascii = ' ';
                    break;
                case '21':
                    ascii = '!';
                    break;
                case '22':
                    ascii = '"';
                    break;
                case '23':
                    ascii = '#';
                    break;
                case '24':
                    ascii = '$';
                    break;
                case '25':
                    ascii = '%';
                    break;
                case '26':
                    ascii = '&';
                    break;
                case '27':
                    ascii = "'";
                    break;
                case '28':
                    ascii = '(';
                    break;
                case '29':
                    ascii = ')';
                    break;
                case '2A':
                    ascii = '*';
                    break;
                case '2B':
                    ascii = '+';
                    break;
                case '2C':
                    ascii = ',';
                    break;
                case '2D':
                    ascii = '-';
                    break;
                case '2E':
                    ascii = '.';
                    break;
                case '2F':
                    ascii = '/';
                    break;
                case '30':
                    ascii = '0';
                    break;
                case '31':
                    ascii = '1';
                    break;
                case '32':
                    ascii = '2';
                    break;
                case '33':
                    ascii = '3';
                    break;
                case '34':
                    ascii = '4';
                    break;
                case '35':
                    ascii = '5';
                    break;
                case '36':
                    ascii = '6';
                    break;
                case '37':
                    ascii = '7';
                    break;
                case '38':
                    ascii = '8';
                    break;
                case '39':
                    ascii = '9';
                    break;
                case '3A':
                    ascii = ':';
                    break;
                case '3B':
                    ascii = ';';
                    break;
                case '3C':
                    ascii = '<';
                    break;
                case '3D':
                    ascii = '=';
                    break;
                case '3E':
                    ascii = '>';
                    break;
                case '3F':
                    ascii = '?';
                    break;
                case '40':
                    ascii = '@';
                    break;
                case '41':
                    ascii = 'A';
                    break;
                case '42':
                    ascii = 'B';
                    break;
                case '43':
                    ascii = 'C';
                    break;
                case '44':
                    ascii = 'D';
                    break;
                case '45':
                    ascii = 'E';
                    break;
                case '46':
                    ascii = 'F';
                    break;
                case '47':
                    ascii = 'G';
                    break;
                case '48':
                    ascii = 'H';
                    break;
                case '49':
                    ascii = 'I';
                    break;
                case '4A':
                    ascii = 'J';
                    break;
                case '4B':
                    ascii = 'K';
                    break;
                case '4C':
                    ascii = 'L';
                    break;
                case '4D':
                    ascii = 'M';
                    break;
                case '4E':
                    ascii = 'N';
                    break;
                case '4F':
                    ascii = 'O';
                    break;
                case '50':
                    ascii = 'P';
                    break;
                case '51':
                    ascii = 'Q';
                    break;
                case '52':
                    ascii = 'R';
                    break;
                case '53':
                    ascii = 'S';
                    break;
                case '54':
                    ascii = 'T';
                    break;
                case '55':
                    ascii = 'U';
                    break;
                case '56':
                    ascii = 'V';
                    break;
                case '57':
                    ascii = 'W';
                    break;
                case '58':
                    ascii = 'X';
                    break;
                case '59':
                    ascii = 'Y';
                    break;
                case '5A':
                    ascii = 'Z';
                    break;
                case '5B':
                    ascii = '[';
                    break;
                case '5C':
                    ascii = '\\';
                    break;
                case '5D':
                    ascii = ']';
                    break;
                case '5E':
                    ascii = '^';
                    break;
                case '5F':
                    ascii = '_';
                    break;
                case '60':
                    ascii = '`';
                    break;
                case '61':
                    ascii = 'a';
                    break;
                case '62':
                    ascii = 'b';
                    break;
                case '63':
                    ascii = 'c';
                    break;
                case '64':
                    ascii = 'd';
                    break;
                case '65':
                    ascii = 'e';
                    break;
                case '66':
                    ascii = 'f';
                    break;
                case '67':
                    ascii = 'g';
                    break;
                case '68':
                    ascii = 'h';
                    break;
                case '69':
                    ascii = 'i';
                    break;
                case '6A':
                    ascii = 'j';
                    break;
                case '6B':
                    ascii = 'k';
                    break;
                case '6C':
                    ascii = 'l';
                    break;
                case '6D':
                    ascii = 'm';
                    break;
                case '6E':
                    ascii = 'n';
                    break;
                case '6F':
                    ascii = 'o';
                    break;
                case '70':
                    ascii = 'p';
                    break;
                case '71':
                    ascii = 'q';
                    break;
                case '72':
                    ascii = 'r';
                    break;
                case '73':
                    ascii = 's';
                    break;
                case '74':
                    ascii = 't';
                    break;
                case '75':
                    ascii = 'u';
                    break;
                case '76':
                    ascii = 'v';
                    break;
                case '77':
                    ascii = 'w';
                    break;
                case '78':
                    ascii = 'x';
                    break;
                case '79':
                    ascii = 'y';
                    break;
                case '7A':
                    ascii = 'z';
                    break;
                case '7B':
                    ascii = '{';
                    break;
                case '7C':
                    ascii = '|';
                    break;
                case '7D':
                    ascii = '}';
                    break;
                case '7E':
                    ascii = '~';
                    break;
                case '7F':
                    ascii = '<DEL>';
                    break;
                case '80':
                    break;
                case '81':
                    break;
                case '82':
                    break;
                case '83':
                    break;
                case '84':
                    break;
                case '85':
                    break;
                case '86':
                    break;
                case '87':
                    break;
                case '88':
                    break;
                case '89':
                    break;
                case '8A':
                    break;
                case '8B':
                    break;
                case '8C':
                    break;
                case '8D':
                    break;
                case '8E':
                    break;
                case '8F':
                    break;
                case '90':
                    break;
                case '91':
                    break;
                case '92':
                    break;
                case '93':
                    break;
                case '94':
                    break;
                case '95':
                    break;
                case '96':
                    break;
                case '97':
                    break;
                case '98':
                    break;
                case '99':
                    break;
                case '9A':
                    break;
                case '9B':
                    break;
                case '9C':
                    break;
                case '9D':
                    break;
                case '9E':
                    break;
                case '9F':
                    break;
                case 'A0':
                    break;
                case 'A1':
                    break;
                case 'A2':
                    break;
                case 'A3':
                    break;
                case 'A4':
                    break;
                case 'A5':
                    break;
                case 'A6':
                    break;
                case 'A7':
                    break;
                case 'A8':
                    break;
                case 'A9':
                    break;
                case 'AA':
                    break;
                case 'AB':
                    break;
                case 'AC':
                    break;
                case 'AD':
                    break;
                case 'AE':
                    break;
                case 'AF':
                    break;
                case 'B0':
                    break;
                case 'B1':
                    break;
                case 'B2':
                    break;
                case 'B3':
                    break;
                case 'B4':
                    break;
                case 'B5':
                    break;
                case 'B6':
                    break;
                case 'B7':
                    break;
                case 'B8':
                    break;
                case 'B9':
                    break;
                case 'BA':
                    break;
                case 'BB':
                    break;
                case 'BC':
                    break;
                case 'BD':
                    break;
                case 'BE':
                    break;
                case 'BF':
                    break;
                case 'C0':
                    break;
                case 'C1':
                    break;
                case 'C2':
                    break;
                case 'C3':
                    break;
                case 'C4':
                    break;
                case 'C5':
                    break;
                case 'C6':
                    break;
                case 'C7':
                    break;
                case 'C8':
                    break;
                case 'C9':
                    break;
                case 'CA':
                    break;
                case 'CB':
                    break;
                case 'CC':
                    break;
                case 'CD':
                    break;
                case 'CE':
                    break;
                case 'CF':
                    break;
                case 'D0':
                    break;
                case 'D1':
                    break;
                case 'D2':
                    break;
                case 'D3':
                    break;
                case 'D4':
                    break;
                case 'D5':
                    break;
                case 'D6':
                    break;
                case 'D7':
                    break;
                case 'D8':
                    break;
                case 'D9':
                    break;
                case 'DA':
                    break;
                case 'DB':
                    break;
                case 'DC':
                    break;
                case 'DD':
                    break;
                case 'DE':
                    break;
                case 'DF':
                    break;
                case 'E0':
                    break;
                case 'E1':
                    break;
                case 'E2':
                    break;
                case 'E3':
                    break;
                case 'E4':
                    break;
                case 'E5':
                    break;
                case 'E6':
                    break;
                case 'E7':
                    break;
                case 'E8':
                    break;
                case 'E9':
                    break;
                case 'EA':
                    break;
                case 'EB':
                    break;
                case 'EC':
                    break;
                case 'ED':
                    break;
                case 'EE':
                    break;
                case 'EF':
                    break;
                case 'F0':
                    break;
                case 'F1':
                    break;
                case 'F2':
                    break;
                case 'F3':
                    break;
                case 'F4':
                    break;
                case 'F5':
                    break;
                case 'F6':
                    break;
                case 'F7':
                    break;
                case 'F8':
                    break;
                case 'F9':
                    break;
                case 'FA':
                    break;
                case 'FB':
                    break;
                case 'FC':
                    break;
                case 'FD':
                    break;
                case 'FE':
                    break;
                case 'FF':
                    break;
                default:
                    ascii = '<<UNHANDLED CODE>>';
                    break;
            }
            x = x + 1;
            cooked = cooked + ascii;
        } else if (hex1 != ' ') {
            cooked.value = cooked.value + '';
        }
    }
    return cooked;
}


function RegionObject(idStr) {

    this._SVGShapes = ["rect", "circle", "ellipse", "line", "polyline", "polygon", "path", "g"];

    this._NodeIdentifier = idStr; // /this is the id of the nodes. IT IS THE
    // RAW AND UNPARSED ID. not really used for
    // anything cuz uid is.

    this._UniqueIdentifiers = []; // /hash of ids

    this._PatternObjects = [];

    this._LastSelectedImage = null;//the last image pattern applied.


    this._LastSelectedHash = null;// for overrideing
    this._isValid = false;
    this._isClippingPath = false;
    // add the identifier
    this.addIdentifier(idStr);

    var nameString = idStr;

    var dividedNameStringArr = [];

    // replace ascii
    nameString = this.parseCharacters(nameString);

    // replace hyphens with spaces
    var re = new RegExp("-", "g");
    nameString = String(nameString).replace(re, " ");

    // split at underscores. ( illustrator puts an underscore after layers with
    // the name id )
    nameString = nameString.split("_")[0];

    // determine if it is going to be used in the project
    var re = new RegExp("^[0-9][0-9]\*");
    this._isValid = re.test(nameString);

    // split at asterisk
    var index = nameString.indexOf("*");

    if (index != -1) {

        dividedNameStringArr = nameString.split("*");
    }

    this._SortOrder = parseFloat(dividedNameStringArr[0]);

    if (!this._SortOrder) {
        var clipRe = new RegExp("^clip");
        if (clipRe.test(dividedNameStringArr[0])) {


            this._isClippingPath = true;

        }
    }
    this._Name = dividedNameStringArr[1];

    // /determine if it has a grain.
    this._HasGrain = false;

    this._HasGrainSource = false;
    this._Grain = null;

    var grainRe = new RegExp("^g");
    if (dividedNameStringArr[2] && grainRe.test(dividedNameStringArr[2])) {

        this._HasGrain = true;

    } else {

        if (dividedNameStringArr[3] && grainRe.test(dividedNameStringArr[3])) {

            this._HasGrain = true;
        }
    }
    this._HasGrainSource = this._HasGrain;

    // /determine if it has a image.
    var imageRe = new RegExp("^i");
    this._HasImage = false;
    this._Image = null;

    if (dividedNameStringArr[2] && imageRe.test(dividedNameStringArr[2])) {

        this._HasImage = true;

    } else {

        if (dividedNameStringArr[3] && imageRe.test(dividedNameStringArr[3])) {

            this._HasImage = true;
        }

    }
    this.ListofGraphicalNodesWithFill = [];
    this._PanelOptions = [];

///G NEW ADDED.
    this._PatternMode = "STRETCH";  // or SCALE
    this._Scale = 1;
    this._Translate = [];
    this._Translate["x"] = 0;
    this._Translate["y"] = 0;
    this._MaterialObject = {

        "color":null,
        "grain":null,
        "image":null,
        "type":"COLOR"    /// or "IMAGE"  color is defailt.
    };   ////PLEASE REFER TO OBJ DEFINITIONS.
}


RegionObject.prototype.parseCharacters = function (test) {

    var re = new RegExp("_x[A-Z0-9][A-Z0-9]_");

    var result = re.exec(test);

    var newStr = test;
    while (result) {

        newStr = String(newStr).replace(re, this.getAsciiChar(String(result)));

        result = re.exec(newStr);
    }
    return newStr;
}


RegionObject.prototype.addIdentifier = function (id) {

    var found = false;
    for (var i = 0; i < this._UniqueIdentifiers.length; i++) {

        if (this._UniqueIdentifiers[i] == id) {

            found = true;
        }
    }
    if (!found) {

        this._UniqueIdentifiers.push(id);
    }
}


RegionObject.prototype.getPatternLink = function (node) {

    var re = new RegExp("url\\(\\#");
    var re2 = new RegExp("\\)");
    var fillAttr = node.getAttribute("fill")

    if (re.test(fillAttr)) {

        fillAttr = fillAttr.replace(re, "");
        fillAttr = fillAttr.replace(re2, "");
    } else {
        fillAttr = null;
    }
    return fillAttr;
}


RegionObject.prototype.getGraphicalChildrenArray = function (d3Obj) {

    var objNodeArr = [];

    for (var i = 0; i < this._SVGShapes.length; i++) {
        // var nodes = d3Obj.querySelectorAll(this._SVGShapes[i]);
        var nodes = d3Obj.querySelectorAll(this._SVGShapes[i]);

        nodes.forEach(node => {
            objNodeArr.push(node);

        })

        // if (nodes && nodes[0]) {

        //     console.log('hello')

        //     var resultArr = nodes[0];

        //     for (var u = 0; u < resultArr.length; u++) {

        //         objNodeArr.push(resultArr[u]);

        //     }
        // }

     }

    // console.log('hello: '+objNodeArr.length)


    return objNodeArr;
}


RegionObject.prototype.initRegionObject = function () {
    
    // //so, all identifiers are added. now we need to figure out which have
    
    // fills and patternfills.

    for (var i = 0; i < this._UniqueIdentifiers.length; i++) {

        // /test parent.


        var mySelfNode = document.getElementById(this._UniqueIdentifiers[i]);
        var mySelfFill = mySelfNode.getAttribute('fill');

        if (mySelfFill && mySelfFill.length > 0) {
            
            // /Test to see if it is a pattern.

            var patternLink = this.getPatternLink(mySelfNode);

            if (patternLink) {

                // d3.select(mySelfNode.setAttribute("patternFill", patternLink));
                mySelfNode.setAttribute("patternFill", patternLink)

            }

            this.ListofGraphicalNodesWithFill.push(mySelfNode)
        }

        // var childArr = this.getGraphicalChildrenArray(d3.select("#" + this._UniqueIdentifiers[i]));

        var childArr = this.getGraphicalChildrenArray(document.getElementById(this._UniqueIdentifiers[i]));

        for (var u = 0; u < childArr.length; u++) {


            var myFill = childArr[u].getAttribute('fill')
            if (myFill && myFill.length > 0) {


                // /Test to see if it is a pattern.

                var patternLink = this.getPatternLink(childArr[u]);

                if (patternLink) {

                    childArr[u].setAttribute("patternFill", patternLink)

                }
                this.ListofGraphicalNodesWithFill.push(childArr[u])
            }
        }
    }
}


RegionObject.prototype.setMaterial = function (type, colorObj, grainObj, imageObj) {


    if (type == "GRAIN") {

        this._MaterialObject["grain"] = grainObj;

    } else {

        if (type == "IMAGE") {
            this._MaterialObject["image"] = imageObj;


        } else {

            this._MaterialObject["color"] = colorObj;

        }
        this._MaterialObject["type"] = type;

    }
}

RegionObject.prototype.getListNode = function () {

  // Create the icons
  var colorIcon = '<i class="fa fa-edit"></i>';
  var grainIcon = '<i class="fa fa-edit"></i>';
  var imageIcon = '<i class="fa fa-edit"></i>';

  // Create the containers
  var container = document.createElement("dl");
  container.className = "region-list-item";

  var titleDT = document.createElement("dt");
  titleDT.textContent = this._Name;

  var colorDD = document.createElement("dd");
  colorDD.className = "cdc-icon-color";
  colorDD.innerHTML = colorIcon;

  var grainDD = document.createElement("dd");
  grainDD.className = "cdc-icon-grain";
  if (this._HasGrain) {
    grainDD.innerHTML = grainIcon;
  } else {
    grainDD.innerHTML = "&nbsp;";
  }

  var imageDD = document.createElement("dd");
  imageDD.className = "cdc-icon-image";
  imageDD.innerHTML = imageIcon;

  // Append elements to the container
  container.appendChild(titleDT);
  container.appendChild(colorDD);
  container.appendChild(grainDD);
  container.appendChild(imageDD);

  // Return the container
  return container;
}